import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07fb546f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"90vh"} }
const _hoisted_2 = { style: {"height":"0.5vh","background-color":"#ccc"} }
const _hoisted_3 = { class: "p-mt-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"20px"},
  class: "pi pi-globe"
}, null, -1))
const _hoisted_5 = { class: "p-mx-1" }
const _hoisted_6 = { class: "p-mx-1" }
const _hoisted_7 = { class: "p-mx-1" }
const _hoisted_8 = { class: "p-mx-1" }
const _hoisted_9 = { class: "p-grid p-m-0" }
const _hoisted_10 = { class: "p-col-9" }
const _hoisted_11 = {
  class: "p-fluid",
  style: {"height":"8vh"}
}
const _hoisted_12 = { class: "p-mr-1" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" NAME : ")
const _hoisted_14 = { class: "pull-right" }
const _hoisted_15 = { class: "p-mx-1" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" EXPIRY DATE : ")
const _hoisted_17 = { class: "pull-right" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" GENERIC : ")
const _hoisted_19 = { class: "pull-right" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" TYPE : ")
const _hoisted_21 = { class: "pull-right" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" BATCH NO : ")
const _hoisted_23 = { class: "pull-right" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Total Units : ")
const _hoisted_25 = { class: "pull-right" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Pack Price : ")
const _hoisted_28 = { class: "pull-right" }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Purchase Price : ")
const _hoisted_31 = { class: "pull-right" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Brand Name : ")
const _hoisted_33 = { class: "pull-right" }
const _hoisted_34 = {
  class: "pos-table",
  style: {"height":"72.7vh"}
}
const _hoisted_35 = { class: "table table-stiped table-bordered p-m-0" }
const _hoisted_36 = { class: "pos-heading" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Mode", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"18rem"} }, "Item", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Unit", -1))
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { style: {"width":"5rem"} }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Expiry", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Disc (%)", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Dis. Flat", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "REMOVE", -1))
const _hoisted_46 = { class: "table-row" }
const _hoisted_47 = ["onUpdate:modelValue", "onChange"]
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "p-pt-2" }
const _hoisted_50 = { class: "p-inputgroup" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "p-inputgroup" }
const _hoisted_53 = { class: "p-pt-2" }
const _hoisted_54 = { class: "p-pt-2" }
const _hoisted_55 = { class: "p-pt-2" }
const _hoisted_56 = { class: "p-inputgroup" }
const _hoisted_57 = { class: "p-pt-2" }
const _hoisted_58 = { class: "p-inputgroup" }
const _hoisted_59 = { class: "p-pt-2" }
const _hoisted_60 = { class: "p-text-center" }
const _hoisted_61 = { class: "item-detail-row" }
const _hoisted_62 = ["colspan"]
const _hoisted_63 = { class: "p-mr-1" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" GENERIC: ")
const _hoisted_65 = { style: {"color":"#fff","background-color":"#c00"} }
const _hoisted_66 = { class: "p-mx-1" }
const _hoisted_67 = { class: "p-mx-1" }
const _hoisted_68 = { class: "p-mx-1" }
const _hoisted_69 = {
  key: 0,
  class: "p-mx-1"
}
const _hoisted_70 = {
  key: 1,
  class: "p-mx-1"
}
const _hoisted_71 = {
  key: 2,
  class: "p-mx-1"
}
const _hoisted_72 = { class: "p-mx-1" }
const _hoisted_73 = {
  class: "p-col-3",
  style: {"border-left":"1px solid #eee"}
}
const _hoisted_74 = { class: "p-fluid" }
const _hoisted_75 = { class: "p-field" }
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" TITLE : ")
const _hoisted_77 = { class: "pull-right" }
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" Email : ")
const _hoisted_79 = { class: "pull-right" }
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" Contact : ")
const _hoisted_81 = { class: "pull-right" }
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" Account Type : ")
const _hoisted_83 = { class: "pull-right" }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { class: "p-error" }
const _hoisted_86 = {
  key: 1,
  class: "p-error"
}
const _hoisted_87 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_88 = { class: "p-field" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Choose Transfer Store ")
], -1))
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { class: "p-error" }
const _hoisted_92 = {
  key: 1,
  class: "p-error"
}
const _hoisted_93 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_94 = { class: "p-field" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Patient Description ")
], -1))
const _hoisted_96 = {
  key: 2,
  class: "p-fluid"
}
const _hoisted_97 = { class: "p-field" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Doctor Description ")
], -1))
const _hoisted_99 = { class: "p-fluid" }
const _hoisted_100 = { class: "p-field" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Receipt Description ")
], -1))
const _hoisted_102 = { class: "p-fluid" }
const _hoisted_103 = { class: "p-field" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Taxes Includes", -1))
const _hoisted_105 = { class: "p-inputgroup" }
const _hoisted_106 = {
  key: 0,
  class: "p-inputgroup-addon"
}
const _hoisted_107 = { class: "p-mx-2" }
const _hoisted_108 = {
  key: 1,
  class: "p-inputgroup-addon"
}
const _hoisted_109 = { class: "p-mx-2" }
const _hoisted_110 = {
  key: 2,
  class: "p-inputgroup-addon"
}
const _hoisted_111 = { class: "p-mx-2" }
const _hoisted_112 = {
  style: {"height":"10vh"},
  class: "p-grid p-m-0 p-p-0"
}
const _hoisted_113 = { class: "set-bottom-amt p-col" }
const _hoisted_114 = /*#__PURE__*/_createTextVNode("Total QTY ")
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_116 = { class: "set-bottom-amt p-col" }
const _hoisted_117 = /*#__PURE__*/_createTextVNode("Total Gross ")
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_119 = { class: "set-bottom-amt p-col" }
const _hoisted_120 = /*#__PURE__*/_createTextVNode("Total Disc ")
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_122 = {
  key: 0,
  class: "set-bottom-amt p-col"
}
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_124 = {
  key: 1,
  class: "set-bottom-amt p-col"
}
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_126 = {
  key: 2,
  class: "set-bottom-amt p-col"
}
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_128 = { class: "set-bottom-amt p-col" }
const _hoisted_129 = /*#__PURE__*/_createTextVNode("Net Total ")
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_131 = { class: "confirmation-content" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_133 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_134 = { class: "p-field" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "search_receipt" }, " Enter Receipt No ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_fullscreen = _resolveComponent("fullscreen")!
  const _component_PaymentScreen = _resolveComponent("PaymentScreen")!
  const _component_ProfilerDialog = _resolveComponent("ProfilerDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_fullscreen, {
      fullscreen: _ctx.screenState.fullscreen,
      "onUpdate:fullscreen": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.screenState.fullscreen) = $event)),
      teleport: _ctx.screenState.teleport,
      "page-only": _ctx.screenState.pageOnly
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.progressBar)
                ? (_openBlock(), _createBlock(_component_ProgressBar, {
                    key: 0,
                    mode: "indeterminate",
                    style: {"height":"0.2em"}
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_Toolbar, { style: {"height":"7.5vh"} }, {
              start: _withCtx(() => [
                _createElementVNode("h5", _hoisted_3, [
                  _createElementVNode("b", null, [
                    _hoisted_4,
                    _createTextVNode(" " + _toDisplayString(_ctx.storeName), 1)
                  ])
                ])
              ]),
              end: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Dropdown, {
                    style: {"width":"10rem"},
                    modelValue: _ctx.item.type,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.type) = $event)),
                    options: _ctx.modeList,
                    optionLabel: "label",
                    optionValue: "value",
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearFreeUnit()))
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Button, {
                    icon: "pi pi-plus",
                    label: "New Profile",
                    class: "p-button-success",
                    onClick: _ctx.openProfileDialog
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_Button, {
                    icon: "pi pi-times",
                    label: "Clear Screen",
                    class: "p-button-danger",
                    onClick: _ctx.clearAll
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  (!_ctx.screenState.fullscreen)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        icon: "pi pi-window-maximize",
                        class: "p-button-warning",
                        onClick: _ctx.toggleScreen
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.screenState.fullscreen)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        icon: "pi pi-window-minimize",
                        class: "p-button-warning",
                        onClick: _ctx.toggleScreen
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_AutoComplete, {
                    delay: 1000,
                    minLength: 3,
                    onItemSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveItem($event))),
                    scrollHeight: "500px",
                    modelValue: _ctx.itemScanBox,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.itemScanBox) = $event)),
                    suggestions: _ctx.itemList,
                    placeholder: " SCAN BARCODE OR SEARCH ITEMS",
                    onComplete: _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchItem($event))),
                    dropdown: false,
                    autoFocus: ""
                  }, {
                    item: _withCtx((slotProps) => [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("b", _hoisted_14, _toDisplayString(slotProps.item.product_name.toUpperCase()), 1)
                        ]),
                        _createElementVNode("span", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("b", _hoisted_17, _toDisplayString(_ctx.formatExpiryDate(slotProps.item.expiry_date)), 1)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, [
                          _hoisted_18,
                          _createElementVNode("b", _hoisted_19, _toDisplayString(slotProps.item.generic.toUpperCase()), 1)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, [
                          _hoisted_20,
                          _createElementVNode("b", _hoisted_21, _toDisplayString(slotProps.item.pType.toUpperCase()), 1)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("small", null, [
                          _hoisted_22,
                          _createElementVNode("b", _hoisted_23, _toDisplayString(slotProps.item.batch_no), 1)
                        ]),
                        _createElementVNode("small", null, [
                          _hoisted_24,
                          _createElementVNode("b", _hoisted_25, _toDisplayString(slotProps.item.qty), 1)
                        ]),
                        (_ctx.item.type != 'TRN')
                          ? (_openBlock(), _createElementBlock("small", _hoisted_26, [
                              _hoisted_27,
                              _createElementVNode("b", _hoisted_28, _toDisplayString(_ctx.currency) + " " + _toDisplayString(slotProps.item.sale_price), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("small", _hoisted_29, [
                              _hoisted_30,
                              _createElementVNode("b", _hoisted_31, _toDisplayString(_ctx.currency) + " " + _toDisplayString(slotProps.item.purchase_price), 1)
                            ])),
                        _createElementVNode("small", null, [
                          _hoisted_32,
                          _createElementVNode("b", _hoisted_33, _toDisplayString(slotProps.item.bName), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "suggestions"])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("table", _hoisted_35, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_36, [
                        _hoisted_37,
                        _hoisted_38,
                        _hoisted_39,
                        (_ctx.item.type == 'TRN')
                          ? (_openBlock(), _createElementBlock("th", _hoisted_40, "Gift Unit"))
                          : _createCommentVNode("", true),
                        _createElementVNode("th", _hoisted_41, "Price (" + _toDisplayString(_ctx.currency) + ")", 1),
                        _hoisted_42,
                        _hoisted_43,
                        _hoisted_44,
                        _createElementVNode("th", null, "Subtotal (" + _toDisplayString(_ctx.currency) + ")", 1),
                        _hoisted_45
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.savedItemList.slice().reverse(), (savedItem) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: savedItem }, [
                          _createElementVNode("tr", _hoisted_46, [
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((savedItem.mode) = $event),
                                onChange: ($event: any) => (_ctx.setPricing(savedItem)),
                                class: "apply-style"
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unitType, (t) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: t,
                                    value: t
                                  }, _toDisplayString(t), 9, _hoisted_48))
                                }), 128))
                              ], 40, _hoisted_47), [
                                [_vModelSelect, savedItem.mode]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_49, [
                              _createElementVNode("small", null, _toDisplayString(_ctx.limitString(savedItem.productName)), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_50, [
                                _createVNode(_component_Button, {
                                  icon: "pi pi-plus",
                                  class: "p-button-success p-p-0",
                                  onClick: ($event: any) => (_ctx.adjustQty('add', savedItem))
                                }, null, 8, ["onClick"]),
                                _createVNode(_component_InputNumber, {
                                  useGrouping: false,
                                  style: {"width":"2rem","height":"35px"},
                                  min: 1,
                                  modelValue: savedItem.unit,
                                  "onUpdate:modelValue": ($event: any) => ((savedItem.unit) = $event),
                                  class: "p-p-0 p-m-0"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                _createVNode(_component_Button, {
                                  icon: "pi pi-minus",
                                  class: "p-button-warning p-p-0",
                                  onClick: ($event: any) => (_ctx.adjustQty('minus', savedItem))
                                }, null, 8, ["onClick"])
                              ])
                            ]),
                            (_ctx.item.type == 'TRN')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_51, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _createVNode(_component_Button, {
                                      icon: "pi pi-plus",
                                      class: "p-button-success p-p-0",
                                      onClick: ($event: any) => (_ctx.adjustFreeQty('add', savedItem))
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_InputNumber, {
                                      useGrouping: false,
                                      style: {"width":"2rem","height":"35px"},
                                      min: 1,
                                      modelValue: savedItem.freeUnit,
                                      "onUpdate:modelValue": ($event: any) => ((savedItem.freeUnit) = $event),
                                      class: "p-p-0 p-m-0"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_Button, {
                                      icon: "pi pi-minus",
                                      class: "p-button-warning p-p-0",
                                      onClick: ($event: any) => (_ctx.adjustFreeQty('minus', savedItem))
                                    }, null, 8, ["onClick"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(savedItem.sellingPrice)), 1),
                            _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.formatExpiryDate(savedItem.expiryDate)), 1),
                            _createElementVNode("td", _hoisted_55, [
                              _createElementVNode("div", _hoisted_56, [
                                _createVNode(_component_InputNumber, {
                                  useGrouping: false,
                                  style: {"width":"2rem","height":"30px"},
                                  min: 0,
                                  minFractionDigits: 2,
                                  maxFractionDigits: 2,
                                  modelValue: savedItem.itemDisc,
                                  "onUpdate:modelValue": ($event: any) => ((savedItem.itemDisc) = $event),
                                  onInput: ($event: any) => (_ctx.getTheSubtotal(savedItem,'discount')),
                                  class: "p-p-0"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, [
                                _createVNode(_component_InputNumber, {
                                  useGrouping: false,
                                  style: {"width":"2rem","height":"30px"},
                                  min: 0,
                                  minFractionDigits: 2,
                                  maxFractionDigits: 2,
                                  modelValue: savedItem.itemDiscFlat,
                                  "onUpdate:modelValue": ($event: any) => ((savedItem.itemDiscFlat) = $event),
                                  onInput: ($event: any) => (_ctx.getTheSubtotal(savedItem,'flat_dis')),
                                  class: "p-p-0"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.getTheSubtotal(savedItem)), 1),
                            _createElementVNode("td", _hoisted_60, [
                              _createVNode(_component_Button, {
                                icon: "pi pi-minus",
                                class: "p-button-danger p-p-1",
                                onClick: ($event: any) => (_ctx.clearListItem(savedItem))
                              }, null, 8, ["onClick"])
                            ])
                          ]),
                          _createElementVNode("tr", _hoisted_61, [
                            _createElementVNode("td", {
                              colspan: _ctx.item.type == 'TRN' ? 9 : 8
                            }, [
                              _createElementVNode("span", _hoisted_63, [
                                _hoisted_64,
                                _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.limitString(savedItem.generic)), 1)
                              ]),
                              _createElementVNode("span", _hoisted_66, " BATCH NO : " + _toDisplayString(savedItem.batchNo), 1),
                              _createElementVNode("span", _hoisted_67, " SHEET SIZE : " + _toDisplayString(savedItem.sheetSize), 1),
                              _createElementVNode("span", _hoisted_68, " PACKSIZE : " + _toDisplayString(savedItem.packSize), 1),
                              (_ctx.taxNames[0].show)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(_ctx.taxNames[0].taxName) + " : " + _toDisplayString(_ctx.fixDigits(savedItem.tax1)) + "% ", 1))
                                : _createCommentVNode("", true),
                              (_ctx.taxNames[1].show)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(_ctx.taxNames[1].taxName) + " : " + _toDisplayString(_ctx.fixDigits(savedItem.tax2)) + "% ", 1))
                                : _createCommentVNode("", true),
                              (_ctx.taxNames[2].show)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_71, _toDisplayString(_ctx.taxNames[2].taxName) + " : " + _toDisplayString(_ctx.fixDigits(savedItem.tax3)) + "% ", 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_72, " TOTAL UNITS : " + _toDisplayString(_ctx.fixDigits(savedItem.totalUnit)), 1)
                            ], 8, _hoisted_62)
                          ])
                        ], 64))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _createVNode(_component_AutoComplete, {
                      delay: 1000,
                      minLength: 3,
                      onItemSelect: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveProfile($event))),
                      scrollHeight: "500px",
                      modelValue: _ctx.v$.selectedProfile.$model,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.selectedProfile.$model) = $event)),
                      suggestions: _ctx.profilerList,
                      placeholder: "Search Profile",
                      onComplete: _cache[7] || (_cache[7] = ($event: any) => (_ctx.searchProfiler($event))),
                      dropdown: false,
                      autoFocus: ""
                    }, {
                      item: _withCtx((slotProps) => [
                        _createElementVNode("div", null, [
                          _hoisted_76,
                          _createElementVNode("b", _hoisted_77, _toDisplayString(slotProps.item.account_title.toUpperCase()), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_78,
                          _createElementVNode("span", _hoisted_79, _toDisplayString(slotProps.item.email_address), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_80,
                          _createElementVNode("span", _hoisted_81, _toDisplayString(slotProps.item.contact_no), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_82,
                          _createElementVNode("span", _hoisted_83, _toDisplayString(slotProps.item.account_type), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "suggestions"]),
                    (_ctx.v$.selectedProfile.$error && _ctx.submitted)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_84, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.selectedProfile.$errors, (error, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              id: "p-error",
                              key: index
                            }, [
                              _createElementVNode("small", _hoisted_85, _toDisplayString(error.$message), 1)
                            ]))
                          }), 128))
                        ]))
                      : (
                    (_ctx.v$.selectedProfile.$invalid && _ctx.submitted) ||
                    _ctx.v$.selectedProfile.$pending.$response
                  )
                        ? (_openBlock(), _createElementBlock("small", _hoisted_86, _toDisplayString(_ctx.v$.selectedProfile.required.$message.replace(
                      "Value",
                      "Profile"
                    )), 1))
                        : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.item.type == 'TRN')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                      _createElementVNode("div", _hoisted_88, [
                        _hoisted_89,
                        _createVNode(_component_Dropdown, {
                          modelValue: _ctx.v$.transferStoreID.$model,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.v$.transferStoreID.$model) = $event)),
                          filter: true,
                          options: _ctx.storeList,
                          optionLabel: "name",
                          optionValue: "id",
                          placeholder: "Search Store"
                        }, null, 8, ["modelValue", "options"]),
                        (_ctx.v$.transferStoreID.$error && _ctx.submitted)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_90, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.transferStoreID.$errors, (error, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  id: "p-error",
                                  key: index
                                }, [
                                  _createElementVNode("small", _hoisted_91, _toDisplayString(error.$message), 1)
                                ]))
                              }), 128))
                            ]))
                          : (
                    (_ctx.v$.transferStoreID.$invalid && _ctx.submitted) ||
                    _ctx.v$.transferStoreID.$pending.$response
                  )
                            ? (_openBlock(), _createElementBlock("small", _hoisted_92, _toDisplayString(_ctx.v$.transferStoreID.required.$message.replace(
                      "Value",
                      "Transfer Store"
                    )), 1))
                            : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.item.type != 'TRN')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                      _createElementVNode("div", _hoisted_94, [
                        _hoisted_95,
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.item.patientDetails,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.item.patientDetails) = $event)),
                          placeholder: "e.g Patient Jhon Doe"
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.item.type != 'TRN')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                      _createElementVNode("div", _hoisted_97, [
                        _hoisted_98,
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.item.doctorDetails,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.item.doctorDetails) = $event)),
                          placeholder: "e.g Dr Jhon Doe"
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("div", _hoisted_100, [
                    _hoisted_101,
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.item.description,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.item.description) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_102, [
                  _createElementVNode("div", _hoisted_103, [
                    _hoisted_104,
                    _createElementVNode("div", _hoisted_105, [
                      (_ctx.taxNames[0].show)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_106, [
                            _createVNode(_component_Checkbox, {
                              disabled: _ctx.taxNames[0].optionalReq == 'Required',
                              modelValue: _ctx.selectedTaxes.tax1,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedTaxes.tax1) = $event)),
                              binary: true
                            }, null, 8, ["disabled", "modelValue"]),
                            _createElementVNode("span", _hoisted_107, _toDisplayString(_ctx.taxNames[0].taxName), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.taxNames[1].show)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_108, [
                            _createVNode(_component_Checkbox, {
                              disabled: _ctx.taxNames[1].optionalReq == 'Required',
                              modelValue: _ctx.selectedTaxes.tax2,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedTaxes.tax2) = $event)),
                              binary: true
                            }, null, 8, ["disabled", "modelValue"]),
                            _createElementVNode("span", _hoisted_109, _toDisplayString(_ctx.taxNames[1].taxName), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.taxNames[2].show)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_110, [
                            _createVNode(_component_Checkbox, {
                              disabled: _ctx.taxNames[2].optionalReq == 'Required',
                              modelValue: _ctx.selectedTaxes.tax3,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedTaxes.tax3) = $event)),
                              binary: true
                            }, null, 8, ["disabled", "modelValue"]),
                            _createElementVNode("span", _hoisted_111, _toDisplayString(_ctx.taxNames[2].taxName), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_112, [
            _createVNode(_component_Button, {
              class: "p-col p-button-success b-style",
              icon: "pi pi-home",
              label: "HOME",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.redirectHome()))
            }),
            _createElementVNode("span", _hoisted_113, [
              _hoisted_114,
              _hoisted_115,
              _createTextVNode(" # " + _toDisplayString(_ctx.savedItemList.length), 1)
            ]),
            _createElementVNode("span", _hoisted_116, [
              _hoisted_117,
              _hoisted_118,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalGross)), 1)
            ]),
            _createElementVNode("span", _hoisted_119, [
              _hoisted_120,
              _hoisted_121,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalDiscAmount)), 1)
            ]),
            (_ctx.taxNames[0].show)
              ? (_openBlock(), _createElementBlock("span", _hoisted_122, [
                  _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[0].taxName) + " ", 1),
                  _hoisted_123,
                  _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax1)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[1].show)
              ? (_openBlock(), _createElementBlock("span", _hoisted_124, [
                  _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[1].taxName) + " ", 1),
                  _hoisted_125,
                  _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax2)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[2].show)
              ? (_openBlock(), _createElementBlock("span", _hoisted_126, [
                  _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[2].taxName) + " ", 1),
                  _hoisted_127,
                  _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax3)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_128, [
              _hoisted_129,
              _hoisted_130,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.netTotal)), 1)
            ]),
            (_ctx.item.type != 'TRN')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 3,
                  class: "p-col p-button-warning b-style",
                  icon: "pi pi-arrow-right",
                  label: "NEXT",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.openPaymentMethod(!_ctx.v$.$invalid))),
                  disabled: _ctx.item.profileID == 0 || _ctx.netTotal <= 0
                }, null, 8, ["disabled"]))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 4,
                  class: "p-col p-button-warning b-style",
                  icon: "pi pi-arrow-right",
                  label: "DONE",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.getProceededPayments([]))),
                  disabled: _ctx.item.profileID == 0 || _ctx.netTotal <= 0
                }, null, 8, ["disabled"]))
          ])
        ]),
        _createVNode(_component_Dialog, {
          visible: _ctx.refundReceiptDialog,
          "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.refundReceiptDialog) = $event)),
          style: { width: '600px' },
          header: "Search Receipt",
          position: "top"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              label: "No",
              icon: "pi pi-times",
              class: "p-button-text",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.refundReceiptDialog = false))
            }),
            _createVNode(_component_Button, {
              label: "Search",
              icon: "pi pi-search",
              class: "p-button-success",
              disabled: _ctx.item.searchReceiptNo == '',
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.fetchReceiptNo()))
            }, null, 8, ["disabled"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_131, [
              _hoisted_132,
              (_ctx.item.type != 'TRN')
                ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                    _createElementVNode("div", _hoisted_134, [
                      _hoisted_135,
                      _createVNode(_component_InputText, {
                        id: "search_receipt",
                        autoFocus: "",
                        modelValue: _ctx.item.searchReceiptNo,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.item.searchReceiptNo) = $event)),
                        placeholder: "e.g INE-02502100000000"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ]),
      _: 1
    }, 8, ["fullscreen", "teleport", "page-only"]),
    _createVNode(_component_PaymentScreen, {
      receiptDetail: {
      dialogStatus: _ctx.paymentDialog,
      itemSource: _ctx.item.type,
      restriction: _ctx.state.selectedProfile == 'Walk In'?'Yes':'No',
      dialogTilte: _ctx.dialogTitle,
      customerID: _ctx.item.profileID,
      customerName: _ctx.state.selectedProfile,
      closeConfirmation: true,
    },
      onClosePaymentScreenEvent: _ctx.closePaymentScreen,
      onGetProceededPaymentsEvent: _ctx.getProceededPayments
    }, null, 8, ["receiptDetail", "onClosePaymentScreenEvent", "onGetProceededPaymentsEvent"]),
    _createVNode(_component_ProfilerDialog, {
      profilerDetail: {
      status: _ctx.profileStatus,
      profilerID: 0,
      statusType: _ctx.statusType,
      dialogTitle: _ctx.dialogTitle,
      currentUserID: _ctx.currentUserID,
    },
      onUpdateProfilerStatus: _ctx.updateProfilerStatus
    }, null, 8, ["profilerDetail", "onUpdateProfilerStatus"])
  ], 64))
}